import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Header from './Header';

const rowStyle = { root: { maxWidth: 0 } };
const Row = injectSheet(rowStyle)(({ row, classes }) => (
    <TableRow hover>
        {row.map((cell, index) => (
            <TableCell
                key={index}
                className={classes.root}
                numeric={index !== 0}
            >
                <Typography noWrap>{cell}</Typography>
            </TableCell>
        ))}
    </TableRow>
));

const totalStyle = { root: { borderBottom: 'none' } };
const Total = injectSheet(totalStyle)(({ row, classes }) => {
    if (!row) {
        return null;
    }
    return (
        <TableRow>
            {row.map((cell, index) => (
                <TableCell
                    key={index}
                    numeric={index !== 0}
                    className={classes.root}
                >
                    <strong>{cell}</strong>
                </TableCell>
            ))}
        </TableRow>
    );
});

const Body = ({ data }) => {
    const rows = data
        .slice(0, -1)
        .map((row, index) => <Row key={index} row={row} />);
    return (
        <TableBody>
            {rows}
            <Total row={data[data.length - 1]} />
        </TableBody>
    );
};

const Report = ({ header, data, loading, classes }) => {
    return (
        <Paper square elevation={1}>
            {loading && <LinearProgress />}
            <Table className={classes.wrapper}>
                <Header header={header} />
                <Body data={data} />
            </Table>
        </Paper>
    );
};

Report.propTypes = {
    header: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
};

const style = ({ spacing }) => ({
    wrapper: {
        marginBottom: spacing.unit * 3,
    },
});

export default injectSheet(style)(Report);



// WEBPACK FOOTER //
// ./src/components/report/Report.js